export default __webpack_public_path__ + "static/media/pain.ccb73f24.jpg";